import React from 'react';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Menu from '../../componentes/menu';
import { usuarioSignal } from '../../signals/usuario';
// Formulários globais
import NaoAutorizado from '../error/NaoAutorizado';
/* @useSignals */
import { Box } from '@mui/material';
import Inicio from './inicio/Inicio';
import Notificacoes from './notificacoes/Notificacoes';
import Automacao from './automacao/Automacao';
import Pacs from './pacs/Pacs';
import DicomHub from './dicom-hub/DicomHub';
import ProtectedRoute from './protectedRoute';
import { Funcionalidade } from '@stt-gestao-pacs/util';
import { primeiraPaginaPermitida } from '../../utils/paginas-permitidas';

const Interno = () => {
    const paginaInicial = primeiraPaginaPermitida(usuarioSignal.value.rbac);

    return (
        <>
            {usuarioSignal.value.autenticado ? (
                <Box sx={{ paddingBottom: 4 }}>
                    <Menu />
                    <Routes>
                        <Route path="/" element={<Navigate replace to={paginaInicial} />} />
                        <Route path="/inicio" element={<ProtectedRoute component={Inicio} funcionalidade={Funcionalidade.PAGINA_ALERTAS} />} />
                        <Route path="/notificacoes" element={<ProtectedRoute component={Notificacoes} funcionalidade={[Funcionalidade.PAGINA_ALERTAS, Funcionalidade.PAGINA_NOTIFICACAO]} />} />
                        <Route path="/automacao" element={<ProtectedRoute component={Automacao} funcionalidade={Funcionalidade.PAGINA_AUTOMACAO} />} />
                        <Route path="/pacs" element={<ProtectedRoute component={Pacs} funcionalidade={Funcionalidade.PAGINA_PACS} />} />
                        <Route path="/dicom-hub" element={<ProtectedRoute component={DicomHub} funcionalidade={[Funcionalidade.PAGINA_DICOM_HUB, Funcionalidade.PAGINA_SERVIDOR_PACS, Funcionalidade.PAGINA_VISUALIZADOR, Funcionalidade.DICOM_HUB_APP]} />} />
                        <Route path="/nao-autorizado" element={<NaoAutorizado />} />
                        <Route path="*" element={<Navigate replace to={paginaInicial} />} />
                    </Routes>
                </Box>
            ) : (
                <Box sx={{ paddingBottom: 4 }}>
                    <NaoAutorizado />
                </Box>
            )}
        </>
    );
};

export default Interno;
